import { Switch } from "@headlessui/react";
import { CheckIcon } from "@heroicons/react/20/solid";
import classNames from "classnames";

interface IProps {
  enabled: boolean;
  setEnabled: (...args: any) => void;
  style?: {
    label?: string;
    checkbox?: string;
    container?: string;
    checkboxIconBorder?: string;
  };
  item?: { label: string; value?: any };
  disabled?: boolean;
}
export default function Checkbox({
  enabled,
  setEnabled,
  item,
  style,
  disabled,
}: IProps) {
  return (
    <div className={classNames("flex", style?.container || "")}>
      <Switch
        checked={enabled}
        onChange={(checked: boolean) => setEnabled(checked, item)}
        disabled={disabled}
        className={classNames(
          "bg-white border ",
          "relative inline-flex rounded justify-center items-center",
          disabled ? "opacity-50 cursor-not-allowed" : "",
          style?.checkbox || "h-5 w-5",
          style?.checkboxIconBorder || "border-gray-400"
        )}
      >
        <CheckIcon
          className={classNames(
            "text-white bg-indigo-600 w-4 h-4",
            enabled ? "block" : "hidden"
          )}
        />
      </Switch>

      <span className={`${style?.label && style?.label}`}>
        {item?.label ?? ""}
      </span>
    </div>
  );
}
